import {
  Box,
  Button,
  Divider,
  Heading,
  useMediaQuery,
} from '@podiumhq/design-system';

import FakeApp from 'components/FakeApp';
import FakeModal from 'components/FakeModal';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';

import { ButtonWrapper } from '../styles';

export const FakeWrapper = ({
  buttonLabel = 'Continue',
  children,
  handleButtonClick,
  marginTop,
  modalWidth,
  padding,
  showIcon,
  title,
  ctaId,
}) => {
  const [isSmallerThan850px] = useMediaQuery(
    `(max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px)`
  );

  const fakeModalDividerStyles = {
    display: isSmallerThan850px ? 'none' : 'block',
    margin: '24px -24px',
    width: 'auto',
  };

  return (
    <>
      <FakeApp />
      <FakeModal
        isMobile={isSmallerThan850px}
        marginTop={marginTop}
        showIcon={showIcon}
        modalWidth={modalWidth}
        padding={padding}
      >
        {title && (
          <>
            <Heading fontSize="2xl" fontWeight="semibold">
              {title}
            </Heading>
            <Divider {...fakeModalDividerStyles} />
          </>
        )}

        <Box>{children}</Box>

        {handleButtonClick && (
          <>
            <Divider {...fakeModalDividerStyles} />
            <ButtonWrapper>
              <Button
                onClick={handleButtonClick}
                size="md"
                style={{ display: 'block' }}
                variant="primary"
                id={ctaId}
              >
                {buttonLabel}
              </Button>
            </ButtonWrapper>
          </>
        )}
      </FakeModal>
    </>
  );
};
